var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Component } from 'react';
import { ThemeProvider } from 'styled-components';
import themes from '@bitcoin-portal/bitcoincom-pkg-theme';
import { FooterWrapper, FooterContent } from './styled';
import Header from './components/Header';
import Sections from './components/Sections';
import { setPreferredLocale, getPreferredLocale, setWindowLocation, getUrl, getLanguageHeader, initAmplitude, sendAmpEvent, } from './helpers';
const supportedLocales = ['en', 'es', 'ru', 'zh', 'ja', 'ko', 'it', 'de', 'fr'];
class Footer extends Component {
    constructor(props) {
        super(props);
        this.setLocale = (locale, internal = false) => {
            const { callback, localeList, cookieName = 'bitcoincom-locale', cookieDomain = 'bitcoin.com', defaultLocale = 'en', } = this.props;
            setPreferredLocale(locale, cookieName, cookieDomain);
            if (typeof callback === 'string' && internal) {
                if (window[callback])
                    window[callback].call(this, locale);
            }
            else if (typeof callback === 'function') {
                callback(locale);
            }
            else if (!callback && localeList && localeList.includes(locale)) {
                setWindowLocation(getUrl(locale, defaultLocale));
            }
            this.setState({ locale, preferredLocale: locale }, () => __awaiter(this, void 0, void 0, function* () {
                yield this.getStrings();
            }));
        };
        this.getLanguages = () => import('./languages').then(({ LOCALES }) => LOCALES);
        this.state = {
            loaded: false,
            locale: getPreferredLocale(),
            legalStrings: { copyright: [] },
            sectionStrings: [],
            originalLocale: props.locale || 'en',
        };
        this.setLocale = this.setLocale.bind(this);
        this.getStrings = this.getStrings.bind(this);
        this.setLocale = this.setLocale.bind(this);
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { locale, cookieName = 'bitcoincom-locale' } = this.props;
            initAmplitude();
            if (locale) {
                const preferredLocale = getPreferredLocale(cookieName);
                const { userAgent } = window.navigator;
                if (userAgent.includes('Mobile')) {
                    this.setState({
                        loaded: true,
                        locale: preferredLocale || locale,
                        preferredLocale,
                    }, () => __awaiter(this, void 0, void 0, function* () {
                        yield this.getStrings();
                    }));
                    return;
                }
                if (preferredLocale && locale !== preferredLocale) {
                    this.setLocale(preferredLocale, true);
                }
                else {
                    this.setState({
                        preferredLocale,
                        locale: preferredLocale || locale,
                    }, () => __awaiter(this, void 0, void 0, function* () {
                        if (!preferredLocale)
                            yield this.getSuggestedLocale();
                        yield this.getStrings();
                    }));
                }
                this.setState({ loaded: true });
            }
            else {
                this.setState({
                    loaded: true,
                    locale,
                    preferredLocale: locale,
                }, () => __awaiter(this, void 0, void 0, function* () {
                    yield this.getStrings();
                }));
            }
        });
    }
    static getDerivedStateFromProps({ isReact = true, locale }, nextState) {
        if (isReact)
            return Object.assign(Object.assign({}, nextState), { locale });
        return Object.assign(Object.assign({}, nextState), { locale: nextState.locale, preferredLocale: nextState.locale });
    }
    getSuggestedLocale() {
        return __awaiter(this, void 0, void 0, function* () {
            const { localeList = supportedLocales, locale } = this.props;
            try {
                const suggestedLocale = getLanguageHeader();
                if (localeList.includes(suggestedLocale)) {
                    this.setState({
                        suggestedLocale,
                        locale: suggestedLocale,
                    });
                }
                else {
                    this.setState({
                        suggestedLocale: locale,
                        locale,
                    });
                }
            }
            catch (err) {
                this.setState({ suggestedLocale: 'en' });
            }
        });
    }
    getStrings() {
        return __awaiter(this, void 0, void 0, function* () {
            const { localeList = supportedLocales, legal, links } = this.props;
            const { suggestedLocale, preferredLocale } = this.state;
            const useLocale = preferredLocale || suggestedLocale;
            const res = useLocale && localeList.includes(useLocale)
                ? yield import(`./i18n/${useLocale}.json`)
                : yield import(`./i18n/en.json`);
            if (window && window.bitcoinComNavbar) {
                window.bitcoinComNavbar.setLocale(useLocale);
            }
            this.setState({
                legalStrings: legal || res.legal,
                sectionStrings: links || res.links,
            });
        });
    }
    render() {
        const { loaded, locale = 'en', legalStrings, sectionStrings } = this.state;
        const { netlify, localeList, contrast = false } = this.props;
        if (!loaded)
            return React.createElement(React.Fragment, null);
        return (React.createElement(React.Fragment, null,
            React.createElement(ThemeProvider, { theme: themes.light },
                React.createElement(FooterWrapper, { contrast: contrast },
                    React.createElement(FooterContent, { contrast: contrast },
                        React.createElement(Header, { contrast: contrast, legalStrings: netlify ? netlify.legal : legalStrings, locale: locale, setSelectedLocale: (lang) => {
                                sendAmpEvent('user_language_preference', {
                                    user_locale: lang,
                                    web_location: 'footer',
                                });
                                this.setLocale(lang, true);
                            }, localesList: localeList }),
                        React.createElement(Sections, { links: netlify ? netlify.links : sectionStrings }))))));
    }
}
export default Footer;
//# sourceMappingURL=Footer.js.map